<template>
<el-card class="price-card" >
  <div class="price-card__title">
    <font-awesome-icon class="price-card__title__icon" :icon="['fal', 'calculator']"/>
    <span class="bold price-card__title__label">{{ $t('validate.estimationPrice') }}</span>
  </div>
  <div class="price-card__body">
    <div class="price-card__body__estim">
      Entre {{ $n(this.estimationResults.low, 'currency') }}
      et {{ $n(this.estimationResults.high, 'currency') }}
    </div>
    <div class="price-card__body__notice"
         v-html="cancelStatus
         ? $t('validate.estimationCancelText') : $t('validate.estimationText')">
    </div>
    <div class="price-card__body__button">
      <button class="nxt-button price-card__body__button--cancel --disabled"
              @click="openCancelProject" :disabled="cancelStatus">
        {{ $t('validate.cancel') }}
      </button>
      <button @click="buttonClick"
        class="nxt-button nxt-button__primary price-card__body__button--next">
        {{ $t('base.confirm') }}
      </button>
    </div>
  </div>
</el-card>
</template>

<script>
import { mapGetters } from 'vuex';
import EventBus from '@/utils/helpers/event-bus';

export default {
  name: 'EstimationPrice',
  props: {
    estimationResults: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      cancelStatus: 'projectStore/cancelStatus',
    }),
  },
  methods: {
    buttonClick(e) {
      this.$emit('nextButtonClick', e);
    },
    openCancelProject() {
      EventBus.$emit('openCancelProject');
    },
  },
};
</script>

<style scoped lang="scss">
.price-card{
  &__title{
    text-transform: uppercase;
    font-size: $--font-size-large;
    display: flex;
    height: 32px;
    margin-bottom: 8px;
    align-items: center;
    &__label{
      padding-left: 8px;
    }
    &__icon {
      height: 32px;
      width: 32px;
    }
  }
  &__body {
    margin: 16px 8px;

    &__estim {
      background-color: $--color-background-sub-menu-light;
      border-radius: 5px;
      padding: 20px;
      font-weight: 600;
      font-size: 30px;
      text-align: center;

      @include breakpoint(mobile){
        font-size: 50px;
      }
    }

    &__button {
      display: none;
      text-align: center;
      @include breakpoint(tablet){
        display: block;
      }

      &--next {
        display: inline-block;
      }

      &--cancel {
        display: inline-block;
        margin-right: 15px;
      }
    }

    &__notice {
      margin: 16px 0;
    }
  }
}
</style>
